import * as types from '@/store/mutation-types'
import store from '@/store'
export default {
    namespaced: true,

    state: {
        customersTypes: []
        // permissionArray: []
    },

    actions: {
        fetchAll ({ commit }) {
            return window.axios.get('/entities/types', { once: true }).then(({ data }) => {
                store.dispatch('configuration/updateCustomerTypes', { data: data })
                commit(types.STORE_CUSTOMERS_TYPES, data)
                return data
            })
        },

        update ({ commit }, { id, name, priceId }) {
            return window.axios.put('/entities/types/', { name, priceId }, { params: { id } }).then(({ data }) => {
                return data
            })
        },

        create ({ commit }, { name, priceId }) {
            return window.axios.post('/entities/types', { name, priceId }).then(({ data }) => {
                return data
            })
        },

        delete ({ commit }, { id }) {
            return window.axios.delete('/entities/types', { params: { id } })
        },

        reset ({ commit }) {
            commit(types.RESET)
        }

        // getPermissionForeachType({ commit }) {
        //     return window.axios.get('/entities/getPermission').finally(({ data }) => {
        //         const fields = [
        //             {
        //                 name: i18n.t('Settings.loyalty'),
        //                 permissionEnum: 0,
        //                 booleanValue: null
        //             },
        //             {
        //                 name: i18n.t('Settings.religion'),
        //                 permissionEnum: 1,
        //                 booleanValue: null
        //             },
        //             {
        //                 name: i18n.t('Settings.personality'),
        //                 permissionEnum: 2,
        //                 booleanValue: null
        //             },
        //             {
        //                 name: i18n.t('Settings.birthdate-client'),
        //                 permissionEnum: 3,
        //                 booleanValue: null
        //             },
        //             {
        //                 name: i18n.t('Settings.weekend'),
        //                 permissionEnum: 4,
        //                 booleanValue: null
        //             },
        //             {
        //                 name: i18n.t('Settings.near-by-pharmacies'),
        //                 permissionEnum: 5,
        //                 booleanValue: null
        //             },
        //             {
        //                 name: i18n.t('Settings.near-by-pharmacies-two'),
        //                 permissionEnum: 6,
        //                 booleanValue: null
        //             },
        //             {
        //                 name: i18n.t('Settings.works-in-centers'),
        //                 permissionEnum: 7,
        //                 booleanValue: null
        //             },
        //             {
        //                 name: i18n.t('Settings.work-hour-from'),
        //                 permissionEnum: 8,
        //                 booleanValue: null
        //             },
        //             {
        //                 name: i18n.t('Settings.work-hour-to'),
        //                 permissionEnum: 9,
        //                 booleanValue: null
        //             },
        //             {
        //                 name: i18n.t('Settings.doctor-hobbies'),
        //                 permissionEnum: 10,
        //                 booleanValue: null
        //             },
        //             {
        //                 name: i18n.t('Settings.visit-notes'),
        //                 permissionEnum: 11,
        //                 booleanValue: null
        //             }
        //         ]
        //         // items replace data when linking
        //         const items = [
        //             {
        //                 customerTypeId: 'cda06b59-e5b7-4c26-6d64-08ddb946469b',
        //                 field: '1,3,4,5,7,8,9,10,11,12' 
        //             },
        //             {
        //                 customerTypeId: 'ecfe07fe-8af1-47c9-6d65-08ddb946469b',
        //                 field: '1,2,3,4,5,6,7,8,10,11,12' 
        //             },
        //             {
        //                 customerTypeId: '6245236d-780a-4eb9-6d66-08ddb946469b',
        //                 field: '2,3,5,6,7,8,10,12' 
        //             }
        //         ]
        //         for (let j = 0; j < items.length; j++) {
        //             const permissionArray = items[j]?.field.split(',')
        //             for (let i = 0; i < fields.length; i++) {
        //                 const number = fields.indexOf(fields[i]) + 1
        //                 if (permissionArray.find(c => +c === number)) {
        //                     fields[i].booleanValue = true
        //                 } else {
        //                     fields[i].booleanValue = false
        //                 }
        //             }
        //         }
        //         commit(types.STORE_PERMISSION_BASED_ON_ENTITY_TYPE, fields)
        //         return data
        //     })
        // }
    },

    mutations: {
        [types.STORE_CUSTOMERS_TYPES](state, customersTypes) {
            state.customersTypes = customersTypes
        },

        [types.RESET](state) {
            state.customersTypes = []
        }
    },

    getters: {}
}